/**
 * loadEditor lazily imports the <yaml-editor> component (registering the custom
 * element as a side effect). It is the ONLY entry into the CodeMirror chunk: pages
 * must never import the component statically, so esbuild's code splitting keeps
 * CodeMirror out of the main bundle (the dynamic import() becomes its own chunk).
 */
let loaded: Promise<void> | undefined;

export function loadEditor(): Promise<void> {
  loaded ??= import("../components/yaml-editor.js").then(() => undefined);
  return loaded;
}
